/*
 * Misoora subscriptions — single source of truth for the product form.
 *
 * The Appstle subscription widget renders its selling_plan radios OUTSIDE the
 * product <form>. Neither the native "Buy it Now" dynamic-checkout button
 * (rendered by {{ form | payment_button }}) nor "Add to cart" can see a plan
 * that lives outside the form, and the order would go through as one-time.
 *
 * On top of that, the bulk model needs a quantity = pack size (a 1/2/3-month
 * plan ships 1/2/3 units, so the price scales with the term). Earlier this was
 * done by multiplying the theme's quantity input — but that input only exists
 * when the merchant keeps "Show quantity" on. Turning it off in the theme
 * editor silently broke the multiply. So we must NOT depend on it.
 *
 * This script keeps two fields IN SYNC inside the product form(s):
 *   - selling_plan : the chosen plan (added on subscription, removed on one-time)
 *   - quantity     : the pack size for the chosen plan
 * It creates its own hidden inputs when the theme doesn't render them, so the
 * purchase is correct regardless of the "Show add to cart"/"Show quantity"
 * theme-editor toggles. product-cart.js no longer touches subscriptions — this
 * is the only place that does, which removes the previous overlap.
 *
 * Pack size comes from the plan name (window.misooraSubPlanName), emitted per
 * product in product-template.liquid. Names are "Monthly" (=1), "2 Months",
 * "3 Months", ... — the Try with Mirra trial group is excluded.
 */
(function () {
  if (window.__misooraBulkQtyInit) return;
  window.__misooraBulkQtyInit = true;

  function isKnownPlan(id) {
    var names = window.misooraSubPlanName || {};
    return id != null && names[String(id)] != null;
  }

  // The currently selected subscription plan id, or null for one-time.
  function checkedPlan() {
    var el = document.querySelector('.appstle_sub_widget input[name="selling_plan"]:checked');
    if (!el) return null;
    var v = el.value;
    return /^\d+$/.test(v) && Number(v) > 0 ? v : null;
  }

  // Pack size = first number in the plan name ("Monthly" -> 1, "3 Months" -> 3).
  function packSizeFor(id) {
    var name = (window.misooraSubPlanName || {})[id];
    var m = name && String(name).match(/(\d+)/);
    var n = m ? parseInt(m[1], 10) : 1;
    return n > 0 ? n : 1;
  }

  // Main-product buy form(s). Found by Shopify's stable section suffixes
  // (__main / sticky / __product_highlight) so discovery does NOT depend on
  // theme markup; the widget's container is an extra fallback. Quick-view and
  // other-product (recommendation) forms are excluded.
  // The product form contains <input name="id"> (the variant id), and a named
  // control shadows the form's own `id` property — so `form.id` returns that
  // INPUT element, not the id string, and `form.id.indexOf(...)` throws, killing
  // sync() entirely. Always read the attribute instead.
  function formId(f) {
    return (f && f.getAttribute && f.getAttribute('id')) || '';
  }

  function mainForms() {
    var forms = [], seen = [];
    function add(f) {
      var id = formId(f);
      if (id && id.indexOf('quick-view') < 0 && seen.indexOf(f) < 0) {
        seen.push(f); forms.push(f);
      }
    }
    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function (f) {
      if (/(__main|sticky|__product_highlight)/.test(formId(f))) add(f);
    });
    var widget = document.querySelector('.appstle_sub_widget');
    var scope = widget && (widget.closest('.product-info') || widget.closest('.product') || widget.closest('main'));
    if (scope) scope.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(add);
    return forms;
  }

  function setHidden(form, name, cls, value) {
    var el = form.querySelector('input.' + cls);
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = name;
      el.className = cls;
      form.appendChild(el);
    }
    el.value = value;
    return el;
  }

  function removeHidden(form, cls) {
    var el = form.querySelector('input.' + cls);
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  // Theme quantity inputs tied to a form (nested or via form="" attr), excluding
  // the hidden one we manage.
  function themeQtyInputs(form) {
    var out = [];
    form.querySelectorAll('input[name="quantity"]:not(.misoora-qty)').forEach(function (i) { out.push(i); });
    var id = formId(form);
    if (id) {
      document.querySelectorAll('input[name="quantity"][form="' + id + '"]:not(.misoora-qty)').forEach(function (i) {
        if (out.indexOf(i) < 0) out.push(i);
      });
    }
    return out;
  }

  function sync() {
    var plan = checkedPlan();
    var isSub = !!(plan && isKnownPlan(plan));
    mainForms().forEach(function (form) {
      if (isSub) {
        setHidden(form, 'selling_plan', 'misoora-selling-plan', plan);
        var pack = String(packSizeFor(plan));
        var theme = themeQtyInputs(form);
        if (theme.length) {
          // A visible quantity selector exists: it is the authoritative
          // quantity field. Remember its baseline once, then reflect pack size
          // (no multiply by its own value -> no compounding).
          theme.forEach(function (q) {
            if (q.getAttribute('data-misoora-base') == null) q.setAttribute('data-misoora-base', q.value || '1');
            q.value = pack;
          });
          removeHidden(form, 'misoora-qty');
        } else {
          // No quantity input at all: own a hidden one so both Buy it Now and
          // Add to cart submit the right quantity.
          setHidden(form, 'quantity', 'misoora-qty', pack);
        }
      } else {
        removeHidden(form, 'misoora-selling-plan');
        removeHidden(form, 'misoora-qty');
        // Restore any visible quantity input we changed.
        themeQtyInputs(form).forEach(function (q) {
          var b = q.getAttribute('data-misoora-base');
          if (b != null) { q.value = b; q.removeAttribute('data-misoora-base'); }
        });
      }
    });
  }

  // Buy it Now / dynamic checkout for SUBSCRIPTIONS.
  // Shopify's native dynamic-checkout (express) button builds its own checkout
  // and does not reliably apply a selling_plan that lives outside its flow — it
  // flickers and falls back to one-time. So when a subscription is selected we
  // take control: add the pack (plan + pack-size quantity) and go straight to
  // checkout. One-time purchases fall through to the native express button.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var area = e.target.closest('.shopify-payment-button, .payment-button-container, .payment-button');
    if (!area) return;
    var plan = checkedPlan();
    if (!plan || !isKnownPlan(plan)) return; // one-time -> let the native button run
    e.preventDefault();
    e.stopImmediatePropagation();
    var form = area.closest('form[data-type="add-to-cart-form"]')
      || document.querySelector('form[id*="__main"][data-type="add-to-cart-form"]');
    var idEl = form && form.querySelector('input[name="id"]');
    if (!idEl || !idEl.value) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(idEl.value), quantity: packSizeFor(plan), selling_plan: Number(plan) }] })
    }).then(function () { window.location.href = root + 'checkout'; })
      .catch(function () { window.location.href = root + 'cart'; });
  }, true); // capture phase: run before Shopify's own handler

  // Add to cart for SUBSCRIPTIONS.
  // The theme's "Add to cart" submits the product form and relies on the hidden
  // selling_plan we inject in sync(). But sync() runs on widget events/timeouts,
  // so if the widget hydrates late or the plan is the default (no change event),
  // the input can be missing at click time and the order falls back to one-time.
  // Buy it Now avoids this by reading the plan live at click; mirror that here by
  // forcing a sync the instant the button is pressed, BEFORE the theme's own
  // @click handler builds the FormData. Capture phase runs ahead of Alpine's
  // bubble-phase listener; we do NOT preventDefault — the theme flow proceeds.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('button[name="add"], .add_to_cart_button')) sync();
  }, true);

  // Keep the form current whenever the plan changes.
  var P = 'AppstleSubscription:SubscriptionWidget:';
  ['SellingPlanSelected', 'sellingPlanChanged', 'SellingPlanDeSelected', 'SellingPlanRemoved', 'widgetInitialised']
    .forEach(function (ev) { document.addEventListener(P + ev, sync); });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'selling_plan') sync();
  });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.appstle_sub_widget')) setTimeout(sync, 60);
  });

  // The widget hydrates after this script runs; sync a few times to catch its
  // default selection even if the customer buys without touching it.
  [300, 700, 1500, 3000].forEach(function (t) { setTimeout(sync, t); });
})();
